import {
	Box,
	Button,
	Center,
	Flex,
	Input,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalHeader,
	ModalOverlay,
	Select,
	SimpleGrid,
	Spinner,
	Stack,
	Text,
	Textarea,
	useDisclosure,
	useToast,
} from '@chakra-ui/react';
import EasyDatePicker from '../../EasyDatePicker/EasyDatePicker';
import { useEffect, useState } from 'react';
import { getAllUsuarios } from '../../../services/usuarios';
import { crearActividad, updateActividad } from '../../../services/actividades';
import {
	errorNotification,
	okNotification,
} from '../../../utils/Notificaciones';
import PromocionProcesoGuiado from './PromocionProcesoGuiado';
import {
	actualizarPedidoEncargos,
	getPedidoEncargoByActividad,
} from '../../../services/pedidos';
import BoxEncargo from '../../Cruce/BoxEncargo';
import { actualizarEncargoPedidos } from '../../../services/encargos';
import BoxPedido from '../../Cruce/BoxPedido';
import { getEncargoPedidoByActividad } from '../../../services/encargos';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const PromocionModal = ({
	isOpen,
	onClose,
	datos,
	isEdit,
	esEncargo = false,
}) => {
	const navigate = useNavigate();
	const [responsables, setResponsables] = useState([]);
	const [needReload, setNeedReload] = useState(true);
	const [formData, setFormData] = useState(datos);
	const [datosSeleccionados, setDatosSeleccionados] = useState(
		esEncargo ? datos.pedidosSeleccionados : datos.encargosSeleccionados,
	);

	esEncargo = esEncargo || datos.entidad_relacionada === 'Encargo';
	const [isLoading, setIsLoading] = useState(false);
	const toast = useToast();

	const [datosEnviados, setDatosEnviados] = useState({});

	const {
		isOpen: isOpenProcesoGuiado,
		onOpen: onOpenProcesoGuiado,
		onClose: onCloseProcesoGuiado,
	} = useDisclosure();
	const { user } = useSelector(state => state.auth);

	useEffect(() => {
		const fetchInfo = async () => {
			setNeedReload(false);
			setIsLoading(true);

			const auxResponsables = await getAllUsuarios();
			setResponsables(auxResponsables);

			if (!isEdit) {
				setFormData({
					...formData,
					responsableUuid: user.uuid,
					estado_actividad: 'Programada',
					modalidad_contacto: 'Llamada',
				});
			} else {
				const promise = esEncargo
					? await getEncargoPedidoByActividad(datos.uuid)
					: await getPedidoEncargoByActividad(datos.uuid);

				setDatosSeleccionados(promise);
			}
			setIsLoading(false);
		};

		needReload && user && fetchInfo();
	}, [
		formData,
		needReload,
		isEdit,
		datos.uuid,
		datos.entidad_relacionada,
		esEncargo,
		user,
	]);

	const handleChange = e => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleChangeDatos = (encargo, e) => {
		let test = datosSeleccionados.find(enc => enc.uuid === encargo);
		test = { ...test, [e.target.name]: e.target.value };
		setDatosSeleccionados([
			...datosSeleccionados.filter(enc => enc.uuid !== encargo),
			test,
		]);
	};

	const getDataForSend = () => {
		return {
			entidad_relacionada: esEncargo ? 'Encargo' : 'Pedido',
			tipo_actividad: 'Promocion',
			modalidad_contacto: formData.modalidad_contacto,
			fecha_vencimiento: formData.fecha_vencimiento,
			fecha_actividad: formData.fecha_actividad,
			fecha_finalizacion:
				formData.estado_actividad === 'Realizada' ? new Date() : null,
			estado_actividad: formData.estado_actividad,
			descripcion: formData.descripcion,
			recordatorio: false,
			recordatorio_fecha: null,
			responsableUuid:
				formData.responsableUuid || formData.responsable?.uuid,
			clienteUuid: datos.cliente.uuid,
			pedidoUuid: datos.pedido?.uuid || datos.pedidoUuid,
			encargoUuid: datos.encargo?.uuid || datos.encargoUuid,
		};
	};

	const handleSubmit = async e => {
		e.preventDefault();

		const notificationMessage = !isEdit
			? 'Actividad creada correctamente'
			: 'Actividad actualizada correctamente';
		const errorMessage = 'Error al crear la actividad';

		try {
			let actividad;

			if (!isEdit) {
				actividad = await crearActividad(getDataForSend());
			} else {
				actividad = await updateActividad(datos.uuid, getDataForSend());
			}

			if (esEncargo) {
				await actualizarEncargoPedidos(datos.encargo?.uuid, {
					pedidosSeleccionados: datosSeleccionados,
					actividadUuid: actividad.uuid,
				});
			} else {
				await actualizarPedidoEncargos(datos.pedido.uuid, {
					encargosSeleccionados: datosSeleccionados,
					actividadUuid: actividad.uuid,
				});
			}

			okNotification(notificationMessage, toast);
			onClose();
			if (!isEdit) navigate(-1);
			window.location.reload();
		} catch (error) {
			console.error(
				'🚀 ~ file: PromocionModal.js:137 ~ handleSubmit ~ error:',
				error,
			);
			errorNotification(errorMessage, toast);
		}
	};

	const handleProcesoGuiado = () => {
		const parseData = getDataForSend();
		setDatosEnviados({
			...parseData,
			responsables,
			encargosSeleccionados: datos.datosSeleccionados,
		});
		onOpenProcesoGuiado();
	};

	const abrirProcesoGuiado = false;
	//formData.estado_actividad === 'Realizada' ||
	//datos.estado_actividad === 'Realizada';

	return (
		<>
			<Modal isOpen={isOpen} onClose={onClose} size='4xl' isCentered>
				<ModalOverlay bgColor='blackAlpha.800' />
				<ModalContent>
					<ModalHeader>Llamada de promoción</ModalHeader>
					<ModalCloseButton />
					<ModalBody>
						{!isLoading && (
							<Stack direction='column' spacing={4}>
								<SimpleGrid
									columns={{ base: 1, md: 2 }}
									spacing={{ base: 1, md: 0 }}
								>
									<Text>Cliente</Text>
									<Input
										name='cliente'
										value={`${datos.cliente?.nombre} ${datos.cliente?.apellidos}`}
										isReadOnly
										isDisabled
									/>
								</SimpleGrid>

								<SimpleGrid
									columns={{ base: 1, md: 2 }}
									spacing={{ base: 1, md: 0 }}
								>
									<Text>Entidad relacionada</Text>
									{esEncargo ? (
										<Input
											name='entidad'
											value={`EN - ${datos.encargo?.inmueble?.tipo_inmueble} ${datos.encargo?.inmueble?.subtipo_inmueble} - ${datos.cliente?.nombre} ${datos.cliente?.apellidos}`}
											isReadOnly
											isDisabled
										/>
									) : (
										<Input
											name='entidad'
											value={`PE - ${datos.pedido?.tipo_inmueble} ${datos.pedido?.subtipo_inmueble} - ${datos.cliente?.nombre} ${datos.cliente?.apellidos}`}
											isReadOnly
											isDisabled
										/>
									)}
								</SimpleGrid>

								<SimpleGrid
									columns={{ base: 1, md: 2 }}
									spacing={{ base: 1, md: 0 }}
								>
									<Text>Modalidad contacto</Text>
									<Select
										name='modalidad_contacto'
										value={formData.modalidad_contacto}
										onChange={handleChange}
										isDisabled={datos.fecha_finalizacion}
									>
										<option value='Llamada'>Llamada</option>
										<option value='Presencial'>
											Presencial
										</option>
									</Select>
								</SimpleGrid>

								<SimpleGrid
									columns={{ base: 1, md: 2 }}
									spacing={{ base: 1, md: 0 }}
								>
									<Text>Responsable</Text>
									<Select
										name='responsableUuid'
										value={formData.responsableUuid}
										onChange={handleChange}
										isDisabled={datos.fecha_finalizacion}
									>
										{responsables.map(responsable => (
											<option
												key={responsable.uuid}
												value={responsable.uuid}
											>
												{responsable.nombre}{' '}
												{responsable.apellidos}
											</option>
										))}
									</Select>
								</SimpleGrid>

								<SimpleGrid
									columns={{ base: 1, md: 2 }}
									spacing={{ base: 1, md: 0 }}
								>
									<Text>Fecha actividad</Text>
									<EasyDatePicker
										name='fecha_actividad'
										value={
											formData.fecha_actividad ||
											new Date()
										}
										handleChange={
											datos.fecha_finalizacion
												? null
												: handleChange
										}
									/>
								</SimpleGrid>

								<SimpleGrid
									columns={{ base: 1, md: 2 }}
									spacing={{ base: 1, md: 0 }}
								>
									<Text>Vencimiento</Text>
									<EasyDatePicker
										name='fecha_vencimiento'
										value={
											formData.fecha_vencimiento ||
											new Date()
										}
										handleChange={
											datos.fecha_finalizacion
												? null
												: handleChange
										}
									/>
								</SimpleGrid>

								<SimpleGrid
									columns={{ base: 1, md: 2 }}
									spacing={{ base: 1, md: 0 }}
								>
									<Text>Estado</Text>
									<Select
										name='estado_actividad'
										value={formData.estado_actividad}
										onChange={handleChange}
										isDisabled={datos.fecha_finalizacion}
									>
										<option value='Programada'>
											Programada
										</option>
										<option value='Realizada'>
											Realizada
										</option>
									</Select>
								</SimpleGrid>

								<Stack direction='column'>
									<Text
										fontWeight='bold'
										textDecoration='underline'
									>
										{esEncargo ? 'Pedidos' : 'Encargos'}{' '}
										seleccionados
									</Text>
									{datosSeleccionados?.map(encargo =>
										esEncargo ? (
											<BoxPedido
												key={encargo.uuid}
												pedido={encargo}
												needInfo={
													formData.estado_actividad ===
													'Realizada'
												}
												handleChange={handleChangeDatos}
												isDisabled={
													datos.fecha_finalizacion
												}
											/>
										) : (
											<BoxEncargo
												key={encargo.uuid}
												encargo={encargo}
												needInfo={
													formData.estado_actividad ===
													'Realizada'
												}
												handleChange={handleChangeDatos}
												isDisabled={
													datos.fecha_finalizacion
												}
											/>
										),
									)}
								</Stack>

								<Text>Descripción</Text>
								<Textarea
									borderLeft='3px solid red'
									name='descripcion'
									value={formData.descripcion}
									onChange={handleChange}
									isDisabled={datos.fecha_finalizacion}
									minH='90px'
								/>

								{datos && !datos.fecha_finalizacion && (
									<Flex gap={0}>
										<Button
											w='100%'
											rounded='none'
											onClick={handleSubmit}
											colorScheme='green'
											isDisabled={!formData.descripcion}
										>
											{isEdit ? 'EDITAR' : 'CREAR'}
										</Button>
										{abrirProcesoGuiado && (
											<Button
												w='100%'
												rounded='none'
												onClick={handleProcesoGuiado}
												colorScheme='blue'
												isDisabled={
													!formData.descripcion
												}
											>
												PROCESO GUIADO
											</Button>
										)}
									</Flex>
								)}
							</Stack>
						)}
						{isLoading && (
							<Box>
								<Text
									textAlign='center'
									my={4}
									fontWeight='bold'
								>
									Cargando...
								</Text>
								<Center p={6}>
									<Spinner size='lg' />
								</Center>
							</Box>
						)}
					</ModalBody>
				</ModalContent>
			</Modal>
			{isOpenProcesoGuiado && (
				<PromocionProcesoGuiado
					isOpen={isOpenProcesoGuiado}
					onClose={onCloseProcesoGuiado}
					datos={datosEnviados}
					onClosePadre={onClose}
				/>
			)}
		</>
	);
};

export default PromocionModal;
